// import React, { useEffect, useMemo, useRef, useCallback } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Form, Spinner } from 'react-bootstrap';
// import { Card } from '@components/card/card';

// import * as Yup from 'yup';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch } from '@store/hooks';
// import { useFormik } from 'formik';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import { type ChartDetiles } from '@store/Finance/ChartAccounts/ChartAccountsModels';
// import {
//   AddGlChartOfAccountsDetails,
//   GetGlChartOfAccountsDetailsList,
//   UpdatGlChartOfAccountsDetails
// } from '@store/Finance/ChartAccounts/ChartAccountsDetailsSlice';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetAccountCategory from '@hooks/Finance/ChartAccountsDetails/useGetAccountCategory';
// import { TreeSelect } from 'antd';

// type Props = {
//   treeDetails: ChartDetiles;
//   breadcrumb: any[];
//   isAdd: boolean;
// };

// const AccountsForm: React.FC<Props> = ({ treeDetails, breadcrumb, isAdd }) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();
//   const { Currency } = useLookupCurrency();
//   const { treeDataAccountCategory } = useGetAccountCategory();

//   // ========= helpers =========
//   const toSafeNumber = (v: any) => {
//     const n = Number(String(v ?? '').replace(/\D/g, ''));
//     return Number.isFinite(n) ? n : 0;
//   };

//   const getNextAccountNumber = useCallback(
//     (parent: ChartDetiles): string => {
//       const children = (data ?? []).filter(a => a.accountParant === parent.id && a.accountType !== 'Future');

//       const maxAccountNumber = children.reduce((max, a) => Math.max(max, toSafeNumber(a.accountNumber)), 0);
//       const parentNoStr = String(parent.accountNumber ?? '');

//       if (parent.accountlevel === 1) {
//         // مستوى 2: نزيد أول 3 أرقام ثم نكمّل أصفار
//         const base3 = maxAccountNumber
//           ? Number(String(maxAccountNumber).padStart(8, '0').slice(0, 3))
//           : Number(parentNoStr.padStart(8, '0').slice(0, 3));
//         return String(base3 + 1).padStart(3, '0') + '00000';
//       }

//       if (parent.accountlevel === 2) {
//         // مستوى 3: زيادة بـ 1000 (حسب منطقك الحالي)
//         const base = maxAccountNumber || toSafeNumber(parent.accountNumber);
//         return String(base + 1000);
//       }

//       if (parent.accountlevel === 3) {
//         // مستوى 4: زيادة بـ 1
//         const base = maxAccountNumber || toSafeNumber(parent.accountNumber);
//         return String(base + 1);
//       }

//       return '';
//     },
//     [data]
//   );

//   const currentFormLevel = isAdd ? (treeDetails?.accountlevel ?? 0) + 1 : treeDetails?.accountlevel ?? 0;

//   const renderAccountNumber = (accountNumber: any, level: number) => {
//     const s = String(accountNumber ?? '');
//     if (!s) return <span className='text-muted'>—</span>;

//     // نلوّن الجزء الخاص بالمستوى الحالي
//     let start = 0;
//     let end = s.length;

//     if (level === 1) {
//       start = 0;
//       end = 1;
//     } else if (level === 2) {
//       start = 1;
//       end = 3;
//     } else if (level === 3) {
//       start = 3;
//       end = 5;
//     } else {
//       start = 5;
//       end = s.length;
//     }

//     return (
//       <div className='fw-bold' style={{ letterSpacing: '3px', fontSize: '1.2rem' }}>
//         {s.slice(0, start)}
//         <span className='text-theme'>{s.slice(start, end)}</span>
//         {s.slice(end)}
//       </div>
//     );
//   };

//   // ========= formik =========
//   const formik = useFormik({
//     initialValues: {
//       id: isAdd ? null : treeDetails?.id ?? '',
//       name: isAdd ? '' : treeDetails?.name ?? '',
//       name2: isAdd ? '' : treeDetails?.name2 ?? '',
//       chartOfAccountsId: treeDetails?.chartOfAccountsId ?? '',
//       accountCategoryId: isAdd ? null : treeDetails?.accountCategoryId ?? null,
//       // مهم: لا نحسب رقم الحساب هنا (حتى لا يعاد حسابه مع enableReinitialize)
//       accountNumber: isAdd ? '' : treeDetails?.accountNumber ?? '',
//       accountParant: isAdd ? treeDetails?.id ?? '' : treeDetails?.accountParant ?? '',
//       accountType: 'Accounts',
//       secondaryFlag: false,
//       primaryParant: null,
//       sequenceNum: isAdd ? '' : treeDetails?.sequenceNum ?? '',
//       budgetingAllowedFlag: isAdd ? false : treeDetails?.budgetingAllowedFlag ?? false,
//       enabledFlag: isAdd ? true : treeDetails?.enabledFlag ?? false,
//       currencyCode: isAdd ? '' : treeDetails?.currencyCode ?? '',
//       accountlevel: isAdd ? (treeDetails?.accountlevel ?? 0) + 1 : treeDetails?.accountlevel ?? 0,
//       isNeedReconcile: isAdd ? true : treeDetails?.isNeedReconcile ?? false
//     },
//     enableReinitialize: true,
//     validationSchema: Yup.object().shape({
//       name: Yup.string()
//         .required(() => t('Required'))
//         .trim(),
//       name2: Yup.string()
//         .required(() => t('Required'))
//         .trim(),
//       currencyCode: Yup.string().required(() => t('Required')),
//       sequenceNum: Yup.number()
//         .typeError(() => t('Required'))
//         .required(() => t('Required')),
//       accountNumber: Yup.string().required(() => t('Required')),
//       accountCategoryId: Yup.mixed()
//         .nullable()
//         .required(() => t('Required'))
//     }),
//     onSubmit: values => {
//       const requestBody = {
//         id: values.id,
//         name: values.name,
//         name2: values.name2,
//         chartOfAccountsId: values.chartOfAccountsId,
//         accountNumber: values.accountNumber?.toString(),
//         accountParant: values.accountParant,
//         accountType: values.accountType,
//         secondaryFlag: values.secondaryFlag,
//         primaryParant: values.primaryParant,
//         sequenceNum: values.sequenceNum,
//         budgetingAllowedFlag: values.budgetingAllowedFlag,
//         currencyCode: values.currencyCode,
//         enabledFlag: values.enabledFlag,
//         accountlevel: values.accountlevel,
//         accountCategoryId: values.accountCategoryId,
//         isNeedReconcile: values.isNeedReconcile // ✅ كان ناقص
//       };

//       const actionToDispatch = isAdd
//         ? AddGlChartOfAccountsDetails(requestBody)
//         : UpdatGlChartOfAccountsDetails(requestBody);

//       dispatch(actionToDispatch)
//         .unwrap()
//         .then(res => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: isAdd ? 'Add' : 'Edit' });
//             dispatch(GetGlChartOfAccountsDetailsList());
//           } else {
//             CustomAlert({ action: 'Error' });
//           }
//         })
//         .catch(() => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//         });
//     }
//   });

//   // ========= Auto-generate accountNumber ONCE per parent (no annoying recalcs) =========
//   const autoGenRef = useRef<{ parentId: string | null; value: string | null }>({ parentId: null, value: null });

//   useEffect(() => {
//     if (!isAdd) {
//       autoGenRef.current = { parentId: null, value: null };
//       return;
//     }

//     const parentId = treeDetails?.id ?? null;
//     if (!parentId) return;

//     const next = getNextAccountNumber(treeDetails);
//     if (!next) return;

//     const current = String(formik.values.accountNumber ?? '');
//     const prev = autoGenRef.current;

//     const parentChanged = prev.parentId !== parentId;
//     const isEmpty = !current;
//     const isStillAuto = prev.value && current === prev.value;

//     // نحدّث فقط إذا:
//     // - الأب تغيّر، أو
//     // - الحقل فاضي، أو
//     // - المستخدم ما عدّل الرقم (لازال نفس الرقم المولّد سابقاً)
//     if (parentChanged || isEmpty || isStillAuto) {
//       formik.setFieldValue('accountNumber', next, false);
//       autoGenRef.current = { parentId, value: next };
//     }
//   }, [isAdd, treeDetails?.id, getNextAccountNumber, formik.values.accountNumber]);

//   // ========= derived =========
//   const parentName = useMemo(() => {
//     if (!formik.values.accountParant) return '';
//     return (data ?? []).find(f => formik.values.accountParant === f.id)?.name2 ?? '';
//   }, [data, formik.values.accountParant]);

//   return (
//     <Card className='h-100 '>
//       <div className='card-header bg-theme bg-opacity-10 border-theme'>
//         <h6 className='m-0 text-theme'>
//           <i className={`fas ${isAdd ? 'fa-plus' : 'fa-edit'} me-2`}></i>
//           {isAdd ? 'إضافة حساب جديد' : 'تعديل الحساب'}
//         </h6>
//       </div>

//       <div className='card-body'>
//         <div className='d-flex rounded-2 bg-theme bg-opacity-5 mb-3 px-3 pt-2 pb-1'>
//           <div className='flex-grow-1'>
//             <Breadcrumb BreadcrumbList={breadcrumb} subtitle={breadcrumb[breadcrumb?.length - 1]?.name} />
//           </div>
//         </div>

//         <Form onSubmit={formik.handleSubmit}>
//           <div className='row mb-4'>
//             <div className='col-xl-6 mb-3'>
//               <Card className='h-100 border-theme'>
//                 <div className='card-body text-center'>
//                   <label className='form-label fw-bold text-theme'>رقم الحساب</label>
//                   <div className='text-center mt-2'>
//                     {renderAccountNumber(formik.values.accountNumber, currentFormLevel)}
//                   </div>
//                 </div>
//               </Card>
//             </div>

//             <div className='col-xl-6 mb-3'>
//               <Card className='h-100 border-theme'>
//                 <div className='card-body text-center'>
//                   <label className='form-label fw-bold text-theme'>الحسـاب الأب</label>
//                   <div className='text-theme fs-6 mt-2'>{parentName}</div>
//                 </div>
//               </Card>
//             </div>
//           </div>

//           <div className='row mb-3'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>اسم الحساب المحلي</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='name2'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.name2}
//                   placeholder='أدخل اسم الحساب باللغة المحلية'
//                 />
//                 {formik.errors.name2 && formik.touched.name2 && (
//                   <div className='text-danger small mt-1'>{formik.errors.name2 as any}</div>
//                 )}
//               </div>
//             </div>

//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>اسم الحساب بالعالمي</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='name'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.name}
//                   placeholder='أدخل اسم الحساب باللغة العالمية'
//                 />
//                 {formik.errors.name && formik.touched.name && (
//                   <div className='text-danger small mt-1'>{formik.errors.name as any}</div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className='row mb-3'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>فئة الحســاب</label>
//                 <TreeSelect
//                   className='w-100'
//                   showSearch
//                   placeholder={i18n.language === 'ar' ? 'إختر فئة الحساب' : 'Choose Account Category'}
//                   allowClear
//                   value={formik.values.accountCategoryId}
//                   onChange={(val: any) => {
//                     formik.setFieldValue('accountCategoryId', val ?? null);
//                     formik.setFieldTouched('accountCategoryId', true, true);
//                   }}
//                   treeData={treeDataAccountCategory}
//                   treeNodeFilterProp='title'
//                   treeDefaultExpandAll
//                   showCheckedStrategy={TreeSelect.SHOW_PARENT}
//                 />
//                 {formik.errors.accountCategoryId && formik.touched.accountCategoryId && (
//                   <div className='text-danger small mt-1'>{formik.errors.accountCategoryId as any}</div>
//                 )}
//               </div>
//             </div>

//             <div className='col-xl-3'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>عملة الحســاب</label>
//                 <Form.Select
//                   className='form-select'
//                   name='currencyCode'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.currencyCode || ''}
//                 >
//                   <option value=''>{i18n.language === 'ar' ? 'إختر العملة' : 'Choose Currency'}</option>
//                   {Currency?.map((item: any) => (
//                     <option key={item.currencyCode} value={item.currencyCode}>
//                       {item.description}
//                     </option>
//                   ))}
//                 </Form.Select>
//                 {formik.errors.currencyCode && formik.touched.currencyCode && (
//                   <div className='text-danger small mt-1'>{formik.errors.currencyCode as any}</div>
//                 )}
//               </div>
//             </div>

//             <div className='col-xl-3'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>الترتيب</label>
//                 <Form.Control
//                   className='form-control text-center'
//                   type='number'
//                   name='sequenceNum'
//                   onChange={e => {
//                     const v = e.target.value;
//                     formik.setFieldValue('sequenceNum', v === '' ? '' : Number(v));
//                   }}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.sequenceNum as any}
//                   placeholder='رقم الترتيب'
//                 />
//                 {formik.errors.sequenceNum && formik.touched.sequenceNum && (
//                   <div className='text-danger small mt-1'>{formik.errors.sequenceNum as any}</div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <Card className='mb-4 border-secondary'>
//             <div className='card-body'>
//               <div className='row'>
//                 <div className='col-xl-4'>
//                   <div className='form-group'>
//                     <Form.Check
//                       type='checkbox'
//                       label='مسموح باستخدامه في الميزانية'
//                       name='budgetingAllowedFlag'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       checked={formik.values.budgetingAllowedFlag}
//                     />
//                   </div>
//                 </div>

//                 {!isAdd && (
//                   <div className='col-xl-4'>
//                     <div className='form-group'>
//                       <Form.Check
//                         type='checkbox'
//                         label='الحساب نشط'
//                         name='enabledFlag'
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         checked={formik.values.enabledFlag}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className='col-xl-4'>
//                   <div className='form-group'>
//                     <Form.Check
//                       type='checkbox'
//                       label='يحتاج إلى تسوية'
//                       name='isNeedReconcile'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       checked={formik.values.isNeedReconcile}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Card>

//           <div className='text-center'>
//             {!isAdd && (
//               <button
//                 disabled={formik.isSubmitting || !treeDetails.enabledFlag}
//                 hidden={treeDetails.accountlevel === 1}
//                 type='submit'
//                 className='btn me-2 btn-theme btn-lg'
//               >
//                 {formik.isSubmitting ? (
//                   <>
//                     <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
//                     جاري الحفظ...
//                   </>
//                 ) : (
//                   <>
//                     <i className='fa fa-save fa-fw me-2'></i>
//                     تعديل الحساب
//                   </>
//                 )}
//               </button>
//             )}

//             {isAdd && (
//               <button disabled={formik.isSubmitting} type='submit' className='btn btn-theme btn-lg'>
//                 {formik.isSubmitting ? (
//                   <>
//                     <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
//                     جاري الإضافة...
//                   </>
//                 ) : (
//                   <>
//                     <i className='fas fa-plus fa-fw me-2'></i>
//                     إضافة حساب جديد
//                   </>
//                 )}
//               </button>
//             )}
//           </div>
//         </Form>
//       </div>
//     </Card>
//   );
// };

// export default AccountsForm;

import React, { useEffect, useMemo, useRef, useCallback } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Form, Spinner } from 'react-bootstrap';
import { Card } from '@components/card/card';

import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import { type ChartDetiles } from '@store/Finance/ChartAccounts/ChartAccountsModels';
import {
  AddGlChartOfAccountsDetails,
  GetGlChartOfAccountsDetailsList,
  UpdatGlChartOfAccountsDetails
} from '@store/Finance/ChartAccounts/ChartAccountsDetailsSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetAccountCategory from '@hooks/Finance/ChartAccountsDetails/useGetAccountCategory';
import { TreeSelect } from 'antd';

type ChartConfig = {
  maxLevel?: number;
  level2?: number | null;
  level3?: number | null;
  level4?: number | null;
  level5?: number | null;
  level6?: number | null;
  level7?: number | null;
};

type Props = {
  treeDetails: ChartDetiles;
  breadcrumb: any[];
  isAdd: boolean;
  chartConfig?: ChartConfig; // ✅ جديد
};

const AccountsForm: React.FC<Props> = ({ treeDetails, breadcrumb, isAdd, chartConfig }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();
  const { Currency } = useLookupCurrency();
  const { treeDataAccountCategory } = useGetAccountCategory();

  // ========= Segment Config (ديناميكي) =========
  const seg = useMemo(() => {
    const maxLevel = Number(chartConfig?.maxLevel ?? 4);

    // fallback إذا الكونفج غير موجود
    const defaults: any = { level2: 2, level3: 2, level4: 3, level5: 2, level6: 2, level7: 2 };

    const lens: number[] = []; // 1-based
    lens[1] = 1; // ✅ حسب كلامك: level1 دائمًا = 1 رقم

    for (let lvl = 2; lvl <= maxLevel; lvl++) {
      const v = Number((chartConfig as any)?.[`level${lvl}`] ?? defaults[`level${lvl}`] ?? 0);
      lens[lvl] = Number.isFinite(v) && v > 0 ? v : 0;
    }

    const starts: number[] = [];
    let pos = 0;
    for (let lvl = 1; lvl <= maxLevel; lvl++) {
      starts[lvl] = pos;
      pos += lens[lvl] || 0;
    }

    const totalLength = pos; // = 1 + sum(level2..maxLevel)

    const onlyDigits = (v: any) => String(v ?? '').replace(/\D/g, '');

    // const normalize = (v: any) => {
    //   const s = onlyDigits(v);
    //   if (!s) return ''.padStart(totalLength, '0');
    //   // إذا أقصر، نكمّل يسار بأصفار (نفس أسلوب الأرقام القديمة)
    //   if (s.length < totalLength) return s.padStart(totalLength, '0');
    //   return s; // لو أطول (نادر) نخليه كما هو
    // };
    const normalize = (v: any) => {
      const s = onlyDigits(v);

      // إذا فاضي: نرجّع رقم كله أصفار بطول الحساب
      if (!s) return ''.padEnd(totalLength, '0');

      // إذا أقصر: نكمّل أصفار من اليمين
      if (s.length < totalLength) return s.padEnd(totalLength, '0');

      // (اختياري لكن أنصح به) إذا أطول: نقصّه للطول الفعلي
      if (s.length > totalLength) return s.slice(0, totalLength);

      return s;
    };

    const getSegment = (acc: string, level: number) => {
      if (!acc) return '';
      const start = starts[level] ?? 0;
      const len = lens[level] ?? 0;
      return acc.slice(start, start + len);
    };

    const splitSegments = (acc: string) => {
      const a = normalize(acc);
      const arr: string[] = [];
      for (let lvl = 1; lvl <= maxLevel; lvl++) {
        arr[lvl] = getSegment(a, lvl) || ''.padStart(lens[lvl] || 0, '0');
      }
      return arr;
    };

    const joinSegments = (parts: string[]) => {
      let out = '';
      for (let lvl = 1; lvl <= maxLevel; lvl++) out += parts[lvl] ?? '';
      return out;
    };

    return { maxLevel, lens, starts, totalLength, onlyDigits, normalize, getSegment, splitSegments, joinSegments };
  }, [chartConfig]);

  // ========= Next Account Number (Dynamic) =========
  const getNextAccountNumber = useCallback(
    (parent: ChartDetiles): string => {
      const parentLevel = Number(parent?.accountlevel ?? 0);
      const childLevel = parentLevel + 1;

      if (childLevel > seg.maxLevel) return '';

      const childSegLen = seg.lens[childLevel] || 0;
      if (childSegLen <= 0) return '';

      const children = (data ?? []).filter(a => a.accountParant === parent.id && a.accountType !== 'Future');

      const maxChildSeg = children.reduce((max, ch) => {
        const n = seg.normalize(ch.accountNumber);
        const s = seg.getSegment(n, childLevel);
        const v = Number(s || '0');
        return Number.isFinite(v) ? Math.max(max, v) : max;
      }, 0);

      const nextVal = maxChildSeg + 1;
      const nextStr = String(nextVal);

      // overflow guard: لو زاد عن طول السيجمنت
      if (nextStr.length > childSegLen) return '';

      const nextSeg = nextStr.padStart(childSegLen, '0');

      // أجزاء الأب
      const parentParts = seg.splitSegments(parent.accountNumber);

      // نبني رقم الابن: (مستويات الأب كما هي) + (سيجمنت الابن الجديد) + (باقي المستويات أصفار)
      const parts: string[] = [];
      for (let lvl = 1; lvl <= seg.maxLevel; lvl++) {
        if (lvl <= parentLevel) parts[lvl] = parentParts[lvl];
        else if (lvl === childLevel) parts[lvl] = nextSeg;
        else parts[lvl] = ''.padStart(seg.lens[lvl] || 0, '0');
      }

      return seg.joinSegments(parts);
    },
    [data, seg]
  );

  const currentFormLevel = isAdd ? (treeDetails?.accountlevel ?? 0) + 1 : treeDetails?.accountlevel ?? 0;

  const renderAccountNumber = (accountNumber: any, level: number) => {
    const s0 = String(accountNumber ?? '');
    const s = seg.normalize(s0);
    if (!s) return <span className='text-muted'>—</span>;

    const lvl = Number(level ?? 0);

    const start = seg.starts[lvl] ?? 0;
    const end = start + (seg.lens[lvl] ?? 0);

    return (
      <div className='fw-bold' style={{ letterSpacing: '3px', fontSize: '1.2rem' }}>
        {s.slice(0, start)}
        <span className='text-theme text-decoration-underline'>{s.slice(start, end)}</span>
        {s.slice(end, seg.totalLength)}
      </div>
    );
  };

  // ========= formik =========
  const formik = useFormik({
    initialValues: {
      id: isAdd ? null : treeDetails?.id ?? '',
      name: isAdd ? '' : treeDetails?.name ?? '',
      name2: isAdd ? '' : treeDetails?.name2 ?? '',
      chartOfAccountsId: treeDetails?.chartOfAccountsId ?? '',
      accountCategoryId: isAdd ? null : treeDetails?.accountCategoryId ?? null,
      accountNumber: isAdd ? '' : treeDetails?.accountNumber ?? '',
      accountParant: isAdd ? treeDetails?.id ?? '' : treeDetails?.accountParant ?? '',
      accountType: 'Accounts',
      secondaryFlag: false,
      primaryParant: null,
      sequenceNum: isAdd ? '' : treeDetails?.sequenceNum ?? '',
      budgetingAllowedFlag: isAdd ? false : treeDetails?.budgetingAllowedFlag ?? false,
      enabledFlag: isAdd ? true : treeDetails?.enabledFlag ?? false,
      currencyCode: isAdd ? '' : treeDetails?.currencyCode ?? '',
      accountlevel: isAdd ? (treeDetails?.accountlevel ?? 0) + 1 : treeDetails?.accountlevel ?? 0,
      isNeedReconcile: isAdd ? true : treeDetails?.isNeedReconcile ?? false
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required(() => t('Required'))
        .trim(),
      name2: Yup.string()
        .required(() => t('Required'))
        .trim(),
      currencyCode: Yup.string().required(() => t('Required')),
      sequenceNum: Yup.number()
        .typeError(() => t('Required'))
        .required(() => t('Required')),
      accountNumber: Yup.string().required(() => t('Required')),
      accountCategoryId: Yup.mixed()
        .nullable()
        .required(() => t('Required'))
    }),
    onSubmit: values => {
      const requestBody = {
        id: values.id,
        name: values.name,
        name2: values.name2,
        chartOfAccountsId: values.chartOfAccountsId,
        // ✅ نضمن الإرسال كرقم/سترينج موحّد بطول صحيح
        accountNumber: seg.normalize(values.accountNumber)?.toString(),
        accountParant: values.accountParant,
        accountType: values.accountType,
        secondaryFlag: values.secondaryFlag,
        primaryParant: values.primaryParant,
        sequenceNum: values.sequenceNum,
        budgetingAllowedFlag: values.budgetingAllowedFlag,
        currencyCode: values.currencyCode,
        enabledFlag: values.enabledFlag,
        accountlevel: values.accountlevel,
        accountCategoryId: values.accountCategoryId,
        isNeedReconcile: values.isNeedReconcile
      };

      const actionToDispatch = isAdd
        ? AddGlChartOfAccountsDetails(requestBody)
        : UpdatGlChartOfAccountsDetails(requestBody);

      dispatch(actionToDispatch)
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: isAdd ? 'Add' : 'Edit' });
            dispatch(GetGlChartOfAccountsDetailsList());
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(() => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  // ========= Auto-generate accountNumber ONCE per parent =========
  const autoGenRef = useRef<{ parentId: string | null; value: string | null }>({ parentId: null, value: null });

  useEffect(() => {
    if (!isAdd) {
      autoGenRef.current = { parentId: null, value: null };
      return;
    }

    const parentId = treeDetails?.id ?? null;
    if (!parentId) return;

    const next = getNextAccountNumber(treeDetails);
    if (!next) return;

    const current = String(formik.values.accountNumber ?? '');
    const prev = autoGenRef.current;

    const parentChanged = prev.parentId !== parentId;
    const isEmpty = !current;
    const isStillAuto = prev.value && current === prev.value;

    if (parentChanged || isEmpty || isStillAuto) {
      formik.setFieldValue('accountNumber', next, false);
      autoGenRef.current = { parentId, value: next };
    }
  }, [isAdd, treeDetails?.id, getNextAccountNumber, formik.values.accountNumber]);

  // ========= derived =========
  const parentName = useMemo(() => {
    if (!formik.values.accountParant) return '';
    return (data ?? []).find(f => formik.values.accountParant === f.id)?.name2 ?? '';
  }, [data, formik.values.accountParant]);

  return (
    <Card className='h-100 '>
      <div className='card-header bg-theme bg-opacity-10 border-theme'>
        <h6 className='m-0 text-theme'>
          <i className={`fas ${isAdd ? 'fa-plus' : 'fa-edit'} me-2`}></i>
          {isAdd ? 'إضافة حساب جديد' : 'تعديل الحساب'}
        </h6>
      </div>

      <div className='card-body'>
        <div className='d-flex rounded-2 bg-theme bg-opacity-5 mb-3 px-3 pt-2 pb-1'>
          <div className='flex-grow-1'>
            <Breadcrumb BreadcrumbList={breadcrumb} subtitle={breadcrumb[breadcrumb?.length - 1]?.name} />
          </div>
        </div>

        <Form onSubmit={formik.handleSubmit}>
          <div className='row mb-4'>
            <div className='col-xl-6 mb-3'>
              <Card className='h-100 border-theme'>
                <div className='card-body text-center'>
                  <label className='form-label fw-bold text-theme'>رقم الحساب</label>
                  <div className='text-center mt-2'>
                    {renderAccountNumber(formik.values.accountNumber, currentFormLevel)}
                  </div>
                  <div className='text-muted small mt-2'>الطول المتوقع: {seg.totalLength}</div>
                </div>
              </Card>
            </div>

            <div className='col-xl-6 mb-3'>
              <Card className='h-100 border-theme'>
                <div className='card-body text-center'>
                  <label className='form-label fw-bold text-theme'>الحسـاب الأب</label>
                  <div className='text-theme fs-6 mt-2'>{parentName}</div>
                </div>
              </Card>
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label fw-bold'>اسم الحساب المحلي</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name2}
                  placeholder='أدخل اسم الحساب باللغة المحلية'
                />
                {formik.errors.name2 && formik.touched.name2 && (
                  <div className='text-danger small mt-1'>{formik.errors.name2 as any}</div>
                )}
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label fw-bold'>اسم الحساب بالعالمي</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder='أدخل اسم الحساب باللغة العالمية'
                />
                {formik.errors.name && formik.touched.name && (
                  <div className='text-danger small mt-1'>{formik.errors.name as any}</div>
                )}
              </div>
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label fw-bold'>فئة الحســاب</label>
                <TreeSelect
                  className='w-100'
                  showSearch
                  placeholder={i18n.language === 'ar' ? 'إختر فئة الحساب' : 'Choose Account Category'}
                  allowClear
                  value={formik.values.accountCategoryId}
                  onChange={(val: any) => {
                    formik.setFieldValue('accountCategoryId', val ?? null);
                    formik.setFieldTouched('accountCategoryId', true, true);
                  }}
                  treeData={treeDataAccountCategory}
                  treeNodeFilterProp='title'
                  treeDefaultExpandAll
                  showCheckedStrategy={TreeSelect.SHOW_PARENT}
                />
                {formik.errors.accountCategoryId && formik.touched.accountCategoryId && (
                  <div className='text-danger small mt-1'>{formik.errors.accountCategoryId as any}</div>
                )}
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label fw-bold'>عملة الحســاب</label>
                <Form.Select
                  className='form-select'
                  name='currencyCode'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.currencyCode || ''}
                >
                  <option value=''>{i18n.language === 'ar' ? 'إختر العملة' : 'Choose Currency'}</option>
                  {Currency?.map((item: any) => (
                    <option key={item.currencyCode} value={item.currencyCode}>
                      {item.description}
                    </option>
                  ))}
                </Form.Select>
                {formik.errors.currencyCode && formik.touched.currencyCode && (
                  <div className='text-danger small mt-1'>{formik.errors.currencyCode as any}</div>
                )}
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label fw-bold'>الترتيب</label>
                <Form.Control
                  className='form-control text-center'
                  type='number'
                  name='sequenceNum'
                  onChange={e => {
                    const v = e.target.value;
                    formik.setFieldValue('sequenceNum', v === '' ? '' : Number(v));
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.sequenceNum as any}
                  placeholder='رقم الترتيب'
                />
                {formik.errors.sequenceNum && formik.touched.sequenceNum && (
                  <div className='text-danger small mt-1'>{formik.errors.sequenceNum as any}</div>
                )}
              </div>
            </div>
          </div>

          <Card className='mb-4 border-secondary'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-xl-4'>
                  <div className='form-group'>
                    <Form.Check
                      type='checkbox'
                      label='مسموح باستخدامه في الميزانية'
                      name='budgetingAllowedFlag'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.budgetingAllowedFlag}
                    />
                  </div>
                </div>

                {!isAdd && (
                  <div className='col-xl-4'>
                    <div className='form-group'>
                      <Form.Check
                        type='checkbox'
                        label='الحساب نشط'
                        name='enabledFlag'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={formik.values.enabledFlag}
                      />
                    </div>
                  </div>
                )}

                <div className='col-xl-4'>
                  <div className='form-group'>
                    <Form.Check
                      type='checkbox'
                      label='يحتاج إلى تسوية'
                      name='isNeedReconcile'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.isNeedReconcile}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <div className='text-center'>
            {!isAdd && (
              <button
                disabled={formik.isSubmitting || !treeDetails.enabledFlag}
                hidden={treeDetails.accountlevel === 1}
                type='submit'
                className='btn me-2 btn-theme btn-lg'
              >
                {formik.isSubmitting ? (
                  <>
                    <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
                    جاري الحفظ...
                  </>
                ) : (
                  <>
                    <i className='fa fa-save fa-fw me-2'></i>
                    تعديل الحساب
                  </>
                )}
              </button>
            )}

            {isAdd && (
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-theme btn-lg'>
                {formik.isSubmitting ? (
                  <>
                    <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
                    جاري الإضافة...
                  </>
                ) : (
                  <>
                    <i className='fas fa-plus fa-fw me-2'></i>
                    إضافة حساب جديد
                  </>
                )}
              </button>
            )}
          </div>
        </Form>
      </div>
    </Card>
  );
};

export default AccountsForm;
